
import { Pie, G2 } from '@antv/g2plot';
import React, { useEffect } from 'react';

const categoryScore = (score) => {
    if(score >= 86) return 'A'
    else if(score >= 76) return 'B'
    else if(score >= 66) return 'C'
    else if(score >= 56) return 'D'
    else if(score >= 0) return 'E'
    else return 'No Data' 
}

const PieChart = ({ sum }) => {
  const G = G2.getEngine('canvas');

  const newSum = Object.entries(
    sum.reduce((acc, s) => {
    //   if (s.totalIdlingDuration) {
    //     acc.Idling = (acc.Idling || 0) + s.totalIdlingDuration;
    //   }
      if (s.harshEvent) {
        acc['Harsh Event'] = (acc['Harsh Event'] || 0) + s.harshEvent;
      }
      if (s.speeding) {
        acc['OverSpeeding'] = (acc['OverSpeeding'] || 0) + s.speeding;
      }
      if (s.total_mdvr_alarm) {
        acc['Video Alarms'] = (acc['Video Alarms'] || 0) + s.total_mdvr_alarm;
      }
      return acc;
    }, {})
  ).map(([name, value]) => ({ name, value }));

  const totalScore = sum?.reduce((acc, cur) => acc + cur.overallScore, 0)
  const calScore = totalScore / sum?.length

    useEffect(() => {
  
      const chart = new Pie('pie-container', {
        appendPadding: 10,
        data: newSum,
        angleField: 'value',
        colorField: 'name',
        radius: 1,
        innerRadius: 0.6,
        legend: false,
        label: {
          type: 'inner',
          offset: '-50%',
          autoRotate: false,
          style: {
            textAlign: 'center',
            fontSize: 14,
          },
          formatter: (data) => {
            const group = new G.Group({});
            group.addShape({
              type: 'text',
              attrs: {
                x: 10,
                y: 8,
                text: `${data.name}`,
                fill: 'rgb(255, 255, 255)',
                fontWeight: 700,
              },
            });
            group.addShape({
              type: 'text',
              attrs: {
                x: 0,
                y: 25,
                text: `${data.value}`,
                fill: 'rgb(255, 255, 255)',
              },
            });
            return group;
          },
        },
        interactions: [{ type: 'element-selected' }, { type: 'element-active' }],
        statistic: {
          title: false,
          content: {
            style: {
              whiteSpace: 'pre-wrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            },
            content: categoryScore(calScore),
          },
        },
      });
  
      chart.render();
  
      return () => {
        chart.destroy();
      };
    }, []);
  
    return <div id='pie-container' />;
  
  // const config = {
  //   data: newSum,
  //   angleField: 'value',
  //   colorField: 'name',
  //   legend: false,
  //   innerRadius: 0.6,
  //   labels: [
  //     { text: 'name', style: { fontSize: 10, fontWeight: 'bold' } },
  //     {
  //       text: (d) =>  d.value || '',
  //       style: {
  //         fontSize: 9,
  //         dy: 12,
  //       },
  //     },
  //   ],
  //   style: {
  //     stroke: '#fff',
  //     inset: 1,
  //     radius: 10,
  //   },
  //   scale: {
  //     color: {
  //       palette: 'spectral',
  //       offset: (t) => t * 0.8 + 0.1,
  //     },
  //   },
  //   annotations: [
  //     {
  //       type: 'text',
  //       style: {
  //         text: categoryScore(calScore),
  //         x: '50%',
  //         y: '50%',
  //         textAlign: 'center',
  //         fontSize: 40,
  //         fontStyle: 'bold',
  //       },
  //     },
  //   ],
  //   tooltip: false,
  // };
  // return (
  //     <Pie {...config} />
  // );
};

export default React.memo(PieChart);
